/**
 * Created by staffanrantzow on 17/03/16.
 */

export const LOGIN_FAILURE = 'auth:login:failure';
export const LOGIN_SUCCESS = 'auth:login:success';
export const LOGOUT = 'auth:logout';



/** WEBPACK FOOTER **
 ** ./src/interactive-solutions/authentication/constants.js
 **/